// extracted by mini-css-extract-plugin
module.exports = {"img":"subscription-logo_img__2awhe"};